<template>
  <b-col :cols="colsSize">
    <b-form-group>
      <label
        class="d-block"
        :for="fieldId"
      >{{ fieldLabel }}</label>
      <validation-provider
        #default="{ errors }"
        :name="fieldLabel"
        :rules="validationRules"
      >
        <component
          :is="componentName"
          :id="fieldId"
          ref="custom_input"
          v-bind="fieldProps"
          :checked="content"
          :value="content"
          :state="errors.length > 0 ? false : null"
          :placeholder="fieldPlaceholder"
          v-on="$listeners"
          @input="handleInput"
        >
          {{ contentText }}
        </component>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </b-col>
</template>

<script>
import {
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BCol,
  BFormRadioGroup,
  BFormTextarea,
  BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { required, url } from '@validations'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    vSelect,
    BCol,
    flatPickr,
    BFormRadioGroup,
    BFormTextarea,
    BFormCheckbox,
  },
  props: {
    value: {
      type: null,
      required: false,
      default: '',
    },
    colsSize: {
      type: [Number, String],
      required: false,
      default: 12,
    },
    componentName: {
      type: String,
      required: false,
      default: 'b-form-input',
    },
    fieldLabel: {
      type: String,
      required: false,
      default: ' ',
    },
    fieldId: {
      type: String,
      required: false,
      default: 'default_id',
    },
    fieldPlaceholder: {
      type: String,
      required: false,
      default: '',
    },
    fieldProps: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
    validationRules: {
      type: String,
      required: false,
      default: '',
    },
    contentText: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      required,
      url,
      content: this.value,
    }
  },
  watch: {
    value: {
      handler() {
        this.content = this.value
      },
      deep: true,
    },
  },
  methods: {
    handleInput(e) {
      this.content = e
      this.$emit('input', e)
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
